import React, { useState, useCallback } from 'react';
import UniversalMediaUploaderStatus from '../../../components/universal-media-uploader-status';
import { useApp } from '../../../hooks/use-app';
import SignaturePreviewDialog from './signature-preview-dialog';

interface SignatureUploaderPreviewProps {
  mediaID: string;
  name?: string;
  size?: number;
  thumbnailURL?: string;
  onRemove?: () => void;
  avatarSize?: 'default' | 'large';
}

const SignatureUploaderPreview: React.FC<SignatureUploaderPreviewProps> = ({
  mediaID,
  name,
  size,
  thumbnailURL,
  onRemove,
  avatarSize = 'default',
}) => {
  const [viewing, setViewing] = useState(false);
  const ctx = useApp();

  const previewURL = ctx.dataSource?.source?.getSignaturePreviewURL(mediaID) ?? '';

  const handleOpen = useCallback(() => {
    setViewing(true);
  }, []);

  const handleClose = useCallback(() => {
    setViewing(false);
  }, []);

  return (
    <>
      <UniversalMediaUploaderStatus
        name={name ?? mediaID}
        size={size}
        thumbnailURL={thumbnailURL}
        onClose={onRemove}
        onClick={handleOpen}
        avatarSize={avatarSize}
        fileType="signature"
      />

      <SignaturePreviewDialog
        open={viewing}
        onClose={handleClose}
        previewURL={previewURL}
      />
    </>
  );
};

export default SignatureUploaderPreview;
